import { Link } from "react-router-dom";
import { Mail, Globe, Twitter, Instagram, Facebook } from "lucide-react";

const COLS = [
  { title: "Shop", links: [["All Products", "/shop"], ["Electronics", "/shop?category=electronics"], ["Wearables", "/shop?category=wearables"], ["Apparel", "/shop?category=apparel"]] },
  { title: "Support", links: [["FAQ", "/faq"], ["Contact Us", "/contact"], ["Track Order", "/track"], ["Shipping", "/shipping"]] },
  { title: "Policies", links: [["Returns & Refunds", "/returns"], ["Privacy Policy", "/privacy"], ["Terms of Service", "/terms"], ["Cookie Policy", "/cookies"]] },
];

export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0B0D16]">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <img src="/logo-clean.png" alt="Drop Worldwide" className="h-14 w-auto object-contain" />
            <p className="mt-4 max-w-sm text-sm text-slate-400">Curated global tech, apparel & everyday innovations — shipped worldwide with buyer protection and fast fulfilment.</p>
            <a href="mailto:support@dropworldwide.com" className="mt-4 inline-flex items-center gap-2 text-sm text-slate-300 hover:text-[#00F0FF]" data-testid="footer-support-email">
              <Mail className="h-4 w-4" /> support@dropworldwide.com
            </a>
            <div className="mt-5 flex gap-3">
              {[Twitter, Instagram, Facebook].map((I, i) => (
                <a key={i} href="#" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-slate-300 transition-colors hover:border-[#00F0FF]/40 hover:text-[#00F0FF]"><I className="h-4 w-4" /></a>
              ))}
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-slate-200">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map(([label, to]) => (
                  <li key={to}><Link to={to} className="text-sm text-slate-400 transition-colors hover:text-[#00F0FF]">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 sm:flex-row">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Drop Worldwide. All rights reserved.</p>
          <p className="flex items-center gap-1.5 font-mono text-xs text-slate-500"><Globe className="h-3.5 w-3.5" /> Shipping to 190+ countries</p>
        </div>
      </div>
    </footer>
  );
}
